// extracted by css-extract-rspack-plugin
export default {"actionBarContainer":"tw4Gb","undoContainer":"PxOFL"};